export enum IMenubarStatus {
  PCE, // 电脑展开
  PCN, // 电脑合并
  PHE, // 手机展开
  PHN, // 手机合并
}
export interface ISetting {
  theme: number;
  color: {
    primary: string;
  };
  mode: "horizontal" | "vertical"; // 导航模式
}
export interface IMenubar {
  status: IMenubarStatus;
  menuList: Array<IMenubarList>;
  isPhone: boolean;
}
export interface IUserInfo {
  id: number;
  name: string;
  username: string;
  expireTime: string;
  usedPort: Number;
  multiAccount: Number;
}
export interface IPlatformAuth {
  list: Array<IPlatformAuthList>;
}
export interface IPlatformAuthList {
  id: Number;
  socialAppType: String;
}
export interface IStatus {
  isLoading: boolean;
  ACCESS_TOKEN: string;
}
export interface IportInfo {
  freePorts: Number;
  total: Number;
  usePorts: Number;
}
export interface ILayout {
  // 左侧导航栏
  menubar: IMenubar;
  // 用户信息
  userInfo: IUserInfo;
  setting: ISetting;
  status: IStatus;
  platformAuth: IPlatformAuth;
  portInfo: IportInfo;
}
export interface IMenubarList {
  parentId?: number | string;
  id?: number | string;
  name: string;
  path: string;
  redirect?: string | { name: string };
  meta: {
    icon?: string;
    activeIcon?: string;
    title: string;
    permission?: string[];
    activeMenu?: string; // 路由设置了该属性，则会高亮相对应的侧边栏
    noCache?: boolean; // 页面是否不缓存
    hidden?: boolean; // 是否隐藏路由
    alwaysShow?: boolean; // 当子路由只有一个的时候是否显示当前路由
  };
  component: (() => Promise<typeof import("*.vue")>) | string;
  children?: Array<IMenubarList>;
}
